export default {
  navigationBarTitleText: '查看服务进度'
};
